export default {"src":"/_next/static/media/enamad.58b31cdc.svg","height":64,"width":59,"blurWidth":0,"blurHeight":0};